module.exports = __webpack_public_path__ + "static/og-f825b970a71a776cc17f2948b8579bfe.png";